import { Component, computed, inject } from "@angular/core";
import { EarnService } from "@bitwarden/web-vault/app/services/earn/earn.service";
import { EarnMask, EarnMaskWithMeta } from "@bitwarden/web-vault/app/models/types/earn.types";
import { EarnConfigType } from "@bitwarden/web-vault/app/models/types/environement-config.type";
import { DataRepositoryService } from "@bitwarden/web-vault/app/services/DataRepository/data-repository.service";
import { TokenService } from "@bitwarden/common/abstractions/token.service";
import { EarnTableStateEnum } from "@bitwarden/web-vault/app/models/enum/earn.enum";
import { TablesFactory } from "@bitwarden/web-vault/app/components/tables/tables.factory";
import { TablesType } from "@bitwarden/web-vault/app/models/enum/tables.enum";
import { EarnVersionTable } from "@bitwarden/web-vault/app/components/tables/earn-tables/tables/version/earn-version.table";

@Component({
  selector: "app-version-history",
  templateUrl: "./version-history.component.html",
})
export class VersionHistoryComponent {
  protected dataRepositoryService = inject(DataRepositoryService);
  protected tokenService = inject(TokenService);
  protected versionTable: EarnVersionTable = new TablesFactory().get(TablesType.EarnVersion, this);
  earnService = inject(EarnService);
}
